import { log } from '@guardian/libs';
const SDK_OPTIONS = {
    enableLogging: true,
    noCookies: true,
    baseUrl: 'https://sdk.fra-01.braze.eu/api/v3',
    sessionTimeoutInSeconds: 1,
    minimumIntervalBetweenTriggerActionsInSeconds: 0,
    devicePropertyAllowlist: [],
};
const initialiseAppboy = async (apiKey) => {
    const importedAppboy = (await import(
    /* webpackChunkName: "braze-web-sdk-core" */ '@braze/web-sdk-core'));
    importedAppboy.setLogger((message) => log('tx', message));
    importedAppboy.initialize(apiKey, SDK_OPTIONS);
    return importedAppboy;
};
const getInitialisedAppboy = (() => {
    let cache;
    return (apiKey) => {
        if (cache === undefined) {
            cache = initialiseAppboy(apiKey);
        }
        return cache;
    };
})();
export { getInitialisedAppboy, SDK_OPTIONS };
